import React from 'react'
import { useNavigate } from 'react-router-dom'

import { createKeyboardClickHandler } from '@/utils'
import { buildDeliverableSetRoute } from '@/utils/routes'

import { MyWorkItemDTO } from '../types'
import { formatMyWorkDate, formatMyWorkTimestamp } from '../utils/dateUtils'

interface MyWorkCompletedCardProps {
  item: MyWorkItemDTO
}

export const MyWorkCompletedCard: React.FC<MyWorkCompletedCardProps> = ({
  item,
}) => {
  const navigate = useNavigate()
  const formattedDueDate = formatMyWorkDate(item.due_date)
  const formattedApprovedAt = formatMyWorkTimestamp(item.approved_at)

  const handleClick = () => {
    navigate(buildDeliverableSetRoute(item.id))
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      onKeyDown={createKeyboardClickHandler(handleClick)}
      className="w-full rounded-lg border border-solid border-gray-200 bg-white p-2xl shadow-sm hover:shadow-lg transition-shadow gap-xl cursor-pointer text-left"
    >
      <div className="space-y-3">
        <div className="gap-x-sm text-base">
          <span className="text-lg font-semibold text-gray-900 leading-snug break-words line-clamp-2">
            {item.deliverable_set_name}
          </span>
          <div>
            <span className="text-primary-900 text-sm">Project:</span>{' '}
            <span className="text-primary-900 font-medium break-words line-clamp-2 text-sm">
              {item.project_name}
            </span>
          </div>
        </div>

        <div className="gap-x-sm text-base">
          <div>
            <span className="text-primary-900 text-sm">Due date:</span>{' '}
            <span className="text-primary-900 font-medium text-sm">
              {formattedDueDate}
            </span>
          </div>

          <div>
            <span className="text-primary-900 text-sm">Completed date:</span>{' '}
            <span className="text-primary-900 font-medium text-sm">
              {formattedApprovedAt}
            </span>
          </div>
        </div>
      </div>
    </button>
  )
}
